const toBlobUrl = async (url, type) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Could not load ffmpeg asset: ${url}`);
    return URL.createObjectURL(
        new Blob([await response.arrayBuffer()], { type })
    );
};

export const defaultOptions = {};

export const getCreateFFmpegCore = async ({
    corePath,
    workerPath,
    wasmPath,
}) => {
    const coreUrl = new URL(corePath, window.location.href).href;
    const loadedCorePath = await toBlobUrl(coreUrl, 'application/javascript');
    const loadedWasmPath = await toBlobUrl(
        wasmPath || coreUrl.replace('ffmpeg-core.js', 'ffmpeg-core.wasm'),
        'application/wasm'
    );
    const loadedWorkerPath = await toBlobUrl(
        workerPath || coreUrl.replace('ffmpeg-core.js', 'ffmpeg-core.worker.js'),
        'application/javascript'
    );

    if (!globalThis.createFFmpegCore) {
        await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = loadedCorePath;
            script.onload = resolve;
            script.onerror = () => reject(new Error('Could not load ffmpeg core'));
            document.head.appendChild(script);
        });
    }

    if (!globalThis.createFFmpegCore) {
        throw new Error('ffmpeg core did not initialize');
    }

    return {
        createFFmpegCore: globalThis.createFFmpegCore,
        corePath: loadedCorePath,
        wasmPath: loadedWasmPath,
        workerPath: loadedWorkerPath,
    };
};

export const fetchFile = async (data) => {
    if (data === undefined) return new Uint8Array();
    if (typeof data === 'string') {
        const response = await fetch(new URL(data, window.location.href).href);
        return new Uint8Array(await response.arrayBuffer());
    }
    if (data instanceof Blob) {
        return new Uint8Array(await data.arrayBuffer());
    }
    return new Uint8Array(data);
};
